import { Modal, ModalOverlay, ModalContent, ModalBody } from '@chakra-ui/react';
import { StepsProvider, Steps, useSteps } from 'react-step-builder';
import { useState } from 'react';
import { BluePrintList } from './blueprint-list';
import { BlueprintDetails } from './blueprint-details';
import { CreateFromBluePrint } from './create-from-blueprint';
import { CreateFromScratch } from './create-from-scratch';
import { useMixpanel } from '@/hooks/use-mixpanel';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { CreateFromScratchWithTitle } from './create-with-title/from-scratch';
import { CreateFromBlueprinthWithTitle } from './create-with-title/from-blueprint';

import { BlueprintListWithDetails } from './blueprint-list-with-details';

const OutreachSteps = ({
  onClose = () => {},
  quickCreate = false,
  ...props
}) => {
  const { feBlueprint } = useFlags();

  const { track } = useMixpanel();
  const { next, jump } = useSteps();
  const [blueprint, setBlueprint] = useState(null);

  const onStartFromScratch = () => {
    const scratchStep = feBlueprint ? 2 : 4;
    jump(scratchStep);
    track({
      event: 'outreach-create-from-scratch',
    });
  };

  const onPreviewBlueprint = (blueprint) => {
    setBlueprint(blueprint);
    next();
    track({
      event: 'blueprint-preview',
    });
  };

  const onCreateFromBlueprint = (blueprint) => {
    setBlueprint(blueprint);
    jump(3);
    track({
      event: 'outreach-create-from-blueprint',
    });
  };

  if (feBlueprint) {
    return (
      <Steps>
        <BlueprintListWithDetails
          onClose={onClose}
          onStartFromScratch={onStartFromScratch}
          onCreateFromBlueprint={onCreateFromBlueprint}
        />
        <CreateFromScratchWithTitle
          onBack={() => {
            jump(1);
          }}
          backText="Back to blueprints"
          onClose={onClose}
          quickCreate={quickCreate}
        />
        <CreateFromBlueprinthWithTitle
          blueprint={blueprint}
          onClose={onClose}
          quickCreate={quickCreate}
        />
      </Steps>
    );
  }

  return (
    <Steps>
      <BluePrintList
        onClose={onClose}
        onStartFromScratch={onStartFromScratch}
        onPreviewBlueprint={onPreviewBlueprint}
        onCreateFromBlueprint={onCreateFromBlueprint}
        {...props}
      />
      <BlueprintDetails blueprint={blueprint} onClose={onClose} />
      <CreateFromBluePrint
        blueprint={blueprint}
        onClose={onClose}
        quickCreate={quickCreate}
      />
      <CreateFromScratch onClose={onClose} quickCreate={quickCreate} />
    </Steps>
  );
};

export const CreateOutreach = ({
  isOpen = true,
  onClose = () => {},
  quickCreate = false,
  ...props
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="6xl"
      isCentered
      closeOnEsc={false}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalBody p="0" h="770px">
          <StepsProvider>
            <OutreachSteps
              onClose={onClose}
              quickCreate={quickCreate}
              {...props}
            />
          </StepsProvider>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
